// src/components/platform/PlatformHero.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@dopomogai/ui';
import { ConsciousNetworkVisual } from '../../visuals/ConsciousNetworkVisual';

interface PlatformHeroProps {
  heroData: {
    headline: string;
    subheadline: string;
    cta: string;
  };
  onAction: (actionType: string, payload?: any) => void;
}

export const PlatformHero: React.FC<PlatformHeroProps> = ({ heroData, onAction }) => {
  return (
    <section className="bg-slate-900 text-white relative overflow-hidden">
      <div className="container mx-auto px-4 py-20 md:py-24">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="relative z-10 text-center md:text-left"
          >
            <h1 className="text-4xl lg:text-5xl font-extrabold leading-tight">
              {heroData.headline}
            </h1>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed">
              {heroData.subheadline}
            </p>
            <div className="mt-10">
              <Button
                text={heroData.cta}
                variant="primary"
                size="lg"
                onClick={() => onAction('SHOW_MODAL', { modalType: 'BETA_WAITLIST' })}
              />
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="h-96"
          >
            <ConsciousNetworkVisual />
          </motion.div>
        </div>
      </div>
    </section>
  );
};